const API_CONFIG = {
    production: true,
    API_BASE_PATH: 'https://api.konnect.conntrix.net/api/v1/',
    API_KEY: '1b066bdb34ae1a28580ce9906ecbfaff43d2e94b',
    WS_BASE_PATH: 'wss://api.konnect.conntrix.net/wss/',
};

export default API_CONFIG;